import { render, staticRenderFns } from "./liveFlv.vue?vue&type=template&id=c92ec3e0&scoped=true&"
import script from "./liveFlv.vue?vue&type=script&lang=js&"
export * from "./liveFlv.vue?vue&type=script&lang=js&"
import style0 from "./liveFlv.vue?vue&type=style&index=0&id=c92ec3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92ec3e0",
  null
  
)

export default component.exports